import { forwardRef } from 'react'
import styled from 'styled-components'
import { Dimensions } from '../../styles'
import { pointerQuery } from '../../styles/dimensions'
import { Motion } from '../../styles/motion'
import { tokens } from '../../styles/tokens'

const { fade, collapse, collapseDelay } = Motion.taskComplete

export const TemplateContainer = styled.div<{ isVisible?: boolean }>`
    width: 100%;
    position: relative;
    height: ${Dimensions.TASK_HEIGHT};
    ${pointerQuery.noHover} {
        height: ${Dimensions.TASK_HEIGHT_TOUCH};
    }
    padding: 1px 0;
    margin: 1px 0;
    opacity: 1;
    transition: opacity ${fade} ${tokens.motion.easeOut};
    /* Completed: fade, then close the row so the tasks below slide up rather than jump. */
    ${({ isVisible }) =>
        !isVisible &&
        `
        height: 0;
        padding: 0;
        margin: 0;
        opacity: 0;
        overflow: hidden;
        /* styled-components emits nested media queries after the block, so the touch height needs its own override */
        ${pointerQuery.noHover} {
            height: 0;
        }
        transition: opacity ${fade} ${tokens.motion.easeIn},
            height ${collapse} ${tokens.motion.easeOut} ${collapseDelay},
            padding ${collapse} ${tokens.motion.easeOut} ${collapseDelay},
            margin ${collapse} ${tokens.motion.easeOut} ${collapseDelay};
    `}
`
interface TaskTemplateProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
    isVisible?: boolean
}
const TaskTemplate = forwardRef<HTMLDivElement, TaskTemplateProps>((props: TaskTemplateProps, ref) => {
    const { children, isVisible = true, ...attr } = props
    return (
        <TemplateContainer ref={ref} isVisible={isVisible} {...attr}>
            {children}
        </TemplateContainer>
    )
})

export default TaskTemplate
